import { makeAutoObservable } from 'mobx'
import { reportError } from 'utils/error'
import { getWorkboxInstance } from 'workboxInstance'

export async function registerMainSession(): Promise<boolean> {
  const wb = getWorkboxInstance()
  if (wb == null) {
    return false
  }
  try {
    const registered = await wb.messageSW({ type: 'REGISTER_MAIN_CLIENT' })
    if (registered) {
      pwaSessionStore.setRegisteredAsMainClient(true)
    }
    return registered
  } catch (err) {
    reportError('registerMainSession()', { metaData: { err } })
    return false
  }
}

export function unregisterMainSession() {
  const wb = getWorkboxInstance()
  wb?.messageSW({ type: 'UNREGISTER_MAIN_CLIENT' })
  pwaSessionStore.setRegisteredAsMainClient(false)
}

export class PwaSessionStore {
  registeredAsMainClient: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setRegisteredAsMainClient(val: boolean) {
    this.registeredAsMainClient = val
  }
}

export const pwaSessionStore = new PwaSessionStore()
